import { render, staticRenderFns } from "./deck-row.vue?vue&type=template&id=646e73e6"
import script from "./deck-row.vue?vue&type=script&lang=js"
export * from "./deck-row.vue?vue&type=script&lang=js"
import style0 from "./deck-row.vue?vue&type=style&index=0&id=646e73e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports